import { useEffect, useRef, useState } from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import MainLayout from "../components/MainLayout";
import AddScreenTitle from "../components/AddScreenTitle";
import GridPage from "../components/GridPage";
import DropDown from "../ReusableComponents/DropDown";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import Buttons from "../components/Buttons";
import { PurchaseHeaders } from "../components/HeaderAttribute";
import TextArea from "../ReusableComponents/TextArea";
import toast from "react-hot-toast";
import {
  BindAPI,
  BindPostAPI,
  IUDAPI,
  ImageAPI,
} from "../services/APIConnection";
import MainPopup from "../popup-containers/MainPopup";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PurchasePopup from "../popup-containers/PurchasePopup";
import UsePrevious from "../Hook/UsePrevious";
import { format } from "date-fns";
import Loader from "../ReusableComponents/Loader";
import ErrorPopup from "../ReusableComponents/ErrorPopup";

const PurchaseItem = () => {
  const [visibleTable, setVisibleTable] = useState(true);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [submitBtnDisabled, setsubmitBtnDisabled] = useState(false);

  const [popUpOpen, setpopUpOpen] = useState(false);
  const [popUpData, setPopUpData] = useState({});
  const [popUpData1, setPopUpData1] = useState({});
  const [popUpDataDD, setPopUpDataDD] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const createdBy = sessionStorage.getItem("createdBy");
  const mstclientId = sessionStorage.getItem("MstClientId");
  const [TxnPurchaseId, setTxnPurchaseId] = useState("");

  const [supplierBindDD, setSupplierBindDD] = useState([]);

  const [allItemCategories, setAllItemCategories] = useState([]);
  const [allItemNames, setAllItemNames] = useState([]);
  const [allItemTypes, setAllItemTypes] = useState([]);

  const [getLocationDatas, setGetLocationDatas] = useState([]);

  const [itemNameDropdown, setItemNameDropdown] = useState([]);
  const [itemTypeDropdown, setItemTypeDropdown] = useState([]);
  const [categoryDropdown, setCategoryDropdown] = useState([]);

  const [bindPurchaseItemData, setBindPurchaseItemData] = useState([]);
  const [bindPurchaseType, setBindPurchaseType] = useState([]);
  const [bindCountryName, setBindCountryName] = useState([]);
  const [bindStateName, setBindStateName] = useState([]);
  const [bindCityName, setBindCityName] = useState([]);

  const [bindPurchaseData, setBindPurchaseData] = useState([]);

  const countryRef = useRef(null);
  const stateRef = useRef(null);
  const branchProjectRef = useRef(null);
  const [formFields, setformFields] = useState({
    txnPurchaseId: "",
    purchaseid: "PUR",
    purchasedate: "",
    purchasetype: "",
    supplierName: "",
    address: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    contactPerson: "",
    designation: "",
    mobileNumber: "",
  });

  const [formFieldsError, setFormFieldsError] = useState({
    purchaseIdError: "PUR",
    purchasedateError: "",
    purchasetypeError: "",
    supplierNameError: "",
    addressError: "",
    countryError: "",
    stateError: "",
    cityError: "",
    pincodeError: "",
    contactPersonError: "",
    designationError: "",
    mobileNumberError: "",
  });

  const [branchProjectBindDD, setBranchProjectBindDD] = useState([]);
  const [stateBindDD, setStateBindDD] = useState([]);
  const [countryBindDD, setCountryBindDD] = useState([]);
  const [mstPurchaseId, setMstPurchaseId] = useState("");
  const [tableData, setTableData] = useState([
    {
      itemType: "",
      category: "",
      itemName: "",
      rate: "",
      quantity: "",
      amount: "",
    },
  ]);
  const [purchaseChildData, setPurchaseChildData] = useState([]);
  useEffect(() => {
    // Load all data in parallel
    initializeData();
  }, []);

  const initializeData = async () => {
    try {
      setIsLoading(true);

      await Promise.all([
        BindPurchase(),
        binddrpCoutrydata(),
        binddrpstatedata(),
        getSelectedLocation(),
      ]);
    } catch (error) {
      console.error("Error initializing data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // 🔹 Purchase Binding
  const BindPurchase = async () => {
    try {
      const requestData = { mstClientId: mstclientId };
      const response = await BindPostAPI(
        requestData,
        "PurchaseAPI/BindPurchase"
      );

      if (response?.data) {
        const data = response.data;
        console.log("BindPurchase", data);

        // Main Data
        setBindPurchaseItemData(data?.Table || []);
        setBindPurchaseChildData(data?.Table5 || []);

        // Dropdowns
        setBindPurchaseType(
          (data?.Table3 || []).map((i) => ({
            value: i.MstPurchaseTypeId,
            label: i.PurchaseType,
          }))
        );

        setItemTypeDropdown(
          (data?.Table1 || []).map((i) => ({
            value: i.MstItemTypeId,
            label: i.ItemType,
          }))
        );

        setCategoryDropdown(
          data?.Table2
        );

        setItemNameDropdown(
          data?.Table4
        );
        // setSupplierBindDD(
        //   (data?.Table6 || []).map((i) => ({
        //     value: i.MstSupplierId,
        //     label: i.SupplierName,
        //   }))
        // );
        setSupplierBindDD(data?.Table6 || []);
        setPurchaseChildData(data?.Table5 || []);
      } else {
        console.error("BindPurchase: Invalid response", response);
      }
    } catch (error) {
      console.error("BindPurchase Error:", error);
    }
  };

  // 🔹 Fetch Country
  const binddrpCoutrydata = async () => {
    try {
      const res = await BindAPI("CountryAPI/BindCountry");
      const list = res?.data?.Table || [];
      setCountryBindDD(
        list.map((m) => ({ value: m.MstCountryId, label: m.CountryName }))
      );
    } catch (error) {
      console.error("Error fetching country data:", error);
    }
  };

  // 🔹 Fetch State
  const binddrpstatedata = async () => {
    try {
      const res = await BindAPI("StateAPI/GetState/");
      const list = res?.data?.Table || [];
      setStateBindDD(
        list.map((m) => ({ value: m.MstStateId, label: m.State }))
      );
    } catch (error) {
      console.error("Error fetching state data:", error);
    }
  };

  // 🔹 Fetch Location
  const getSelectedLocation = async () => {
    try {
      const res = await BindAPI("CityAPI/BindCity");
      setGetLocationDatas(res?.data?.Table || []);
      console.log("locationResponse", res);
    } catch (error) {
      console.error("Error fetching location data:", error);
    }
  };

  const handleSupplierChange = (selectedOption) => {
    if (!selectedOption) return;
  
    const supplier = selectedOption.data;
  
    setformFields((prev) => ({
      ...prev,
      supplierName: selectedOption.value,

      address: supplier.SupplierAddress || "",
      country: supplier.MstCountryId || "",
      state: supplier.MstStateId || "",
      city: supplier.MstCityId || "",
      pincode: supplier.SupplierPincode || "",
      contactPerson: supplier.SupplierContactPersonName || "",
      designation: supplier.SupplierContactPersonDesignation || "",
      mobileNumber: supplier.SupplierMobileNumber || "",
    }));
  };

  useEffect(() => {
    const stateSelectedValue = getLocationDatas.find(
      (item) => item.MstStateId == formFields.state
    );
    console.log("stateSelectedValue", getLocationDatas, formFields);
    if (stateSelectedValue) {
      const branchProjectLabels = getLocationDatas
        .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
        .map((item) => ({
          MstCityId: item.MstCityId,
          City: item.City,
        }));
      const branchProjectSelected = branchProjectLabels.map((LC) => ({
        value: LC.MstCityId,
        label: LC.City,
      }));
      setBranchProjectBindDD(branchProjectSelected);
    } else {
    }
  }, [formFields.state]);

  const handleEdit = (rowIndex) => {
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    setTxnPurchaseId(bindPurchaseItemData[rowIndex].TxnPurchaseId);

    console.log("Test", bindPurchaseItemData);
    const selectedRow = bindPurchaseItemData[rowIndex];

    const selectedTxnId = selectedRow.TxnPurchaseId;

    setMstPurchaseId(selectedRow.TxnPurchaseId);

    const formattedDate = selectedRow.PurchaseDate
      ? format(new Date(selectedRow.PurchaseDate), "yyyy-MM-dd")
      : "";

    setformFields({
      ...formFields,
      txnPurchaseId: selectedRow.TxnPurchaseId || "",
      purchaseid: selectedRow.PurchaseId || "",
      purchasedate: formattedDate,
      purchasetype: selectedRow.PurchaseType || "",
      supplierName: selectedRow.MstSupplierId || "",
      address: selectedRow.Address || "",
      country: selectedRow.MstCountryId || "",
      state: selectedRow.MstStateId || "",
      city: selectedRow.MstCityId || "",
      pincode: selectedRow.Pincode || "",
      contactPerson: selectedRow.ContactPerson || "",
      designation: selectedRow.Designation || "",
      mobileNumber: selectedRow.MobileNumber || "",
    });

    setTableData([
      {
        itemType: selectedRow.MstItemTypeId,
        itemCategoryId: selectedRow.MstItemCategoryId,
        itemName: selectedRow.MstItemId,
        uom: selectedRow.UOM,
        quantity: selectedRow.Quantity,
        rate: selectedRow.Rate,
        amount: selectedRow.Amount,
        itemCategoryList: [],
        itemList: [],
      },
    ]);
    // child items
    if (!selectedTxnId) {
      console.error("TxnPurchaseId not found for row:", rowIndex);
      return;
    }
  };

  const appendDataToConsumeTable = (newDataString) => {
    const newDataArray = JSON.parse(newDataString);
    handleDeleteRow(0);
    setTableData([]);
    const formattedDataArray = newDataArray.map((data) => {
      return {
        itemType: data.MstItemTypeId,
        itemCategoryId: data.MstItemCategoryId,
        itemName: parseInt(data.MstItemId, 10),
        rate: data.Rate.toString(),
        uom: data.UOM,
        amount: data.Amount,
        quantity: data.Quantity,
        currentQty: data.Quantity,
      };
    });

    setTableData((prevData) => [...prevData, ...formattedDataArray]);
    updateTableData1(formattedDataArray);
    convertArrayToJSONString(formattedDataArray);
  };
  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      console.log("data", tableData);

      console.log("JsonString", jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };

  const previousTableData = UsePrevious(tableData);
  useEffect(() => {
    updateTableData();
  }, [tableData]);

  const updateTableData = async () => {
    if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
      const updatedTableData = [...tableData];
      console.log(updateTableData);
      console.log("itemcategory", categoryDropdown);

      for (const row of updatedTableData) {
        // Update itemCategoryList if itemtype is selected
        if (row?.itemType) {
          const filteredCategories = categoryDropdown
            .filter((item) => item.MstItemTypeId == row.itemType)
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.itemCategoryList = filteredCategories;
          console.log(row.itemCategoryList);
        }

        // Update itemList and uom if itemcategory is selected
        if (row?.itemCategoryId) {
          const filteredItems = itemNameDropdown

            .filter((item) => item.MstItemCategoryId === row.itemCategoryId)
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.itemList = filteredItems;
          console.log(row.itemList);

          const selectedItem = filteredItems.find(
            (item) => item.value === row.itemName
          );
          row.uom = selectedItem?.uom || "";
        }
        if (row?.itemName && updateScreenTitle) {
          const data = {
            mstClientId: parseInt(mstclientId || 0),
            mstItemTypeId: parseInt(row.itemType || 0),
            mstCategoryId: parseInt(row.itemCategoryId || 0),
            mstNameId: parseInt(row.itemName || 0),
          };

          try {
            const response = await BindPostAPI(
              data,
              "PurchaseAPI/BindAvailableStock"
            );

            const balanceQuantity =
              response?.data?.Table?.[0]?.RemainingQuantity || "";
            row.currentStock =
              balanceQuantity > row.currentQty
                ? 0
                : row.currentQty - balanceQuantity;
            row.currentDelete = balanceQuantity;
            console.log("balanceQuantity", balanceQuantity);
          } catch (error) {
            console.error("Error fetching current stock:", error);
            row.currentStock = ""; // Reset on error
          }
        }
      }

      setTableData(updatedTableData);
    }
  };
  const updateTableData1 = async () => {
    if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
      const updatedTableData = [...tableData];
      console.log(updateTableData);
      console.log("itemcategory", categoryDropdown);

      for (const row of updatedTableData) {
        if (row?.itemType) {
          const filteredCategories = categoryDropdown
            .filter((item) => item.MstItemTypeId === row.itemType)
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.itemCategoryList = filteredCategories;
          console.log(row.itemCategoryList);
        }

        if (row?.itemCategoryId) {
          const filteredItems = itemNameDropdown

            .filter((item) => item.MstItemCategoryId === row.itemCategoryId)
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.itemList = filteredItems;
          console.log(row.itemList);

          const selectedItem = filteredItems.find(
            (item) => item.value === row.itemName
          );
        }
      }

      setTableData(updatedTableData);
    }
  };

  const [bindPurchaseChildData, setBindPurchaseChildData] = useState([]);
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(false);
    setAddScreenTitle(true);
  };
  const handlePurchase = (rowIndex, flag) => {
    handleOpen(true);
    setpopUpOpen(true);

    // handle flags
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }

    // ✅ Check if row exists
    const rowData = bindPurchaseItemData?.[rowIndex];
    if (!rowData) {
      console.error("No purchase data found for rowIndex:", rowIndex);
      return;
    }

    setBindPurchaseData(rowData);
    setformFields({
      ...formFields,
      txnPurchaseId: rowData.TxnPurchaseId,
    });

    const data = [
      {
        itemType: rowData.MstItemTypeId,
        itemCategoryId: rowData.MstItemCategoryId,
        itemName: rowData.MstItemId,
        uom: rowData.UOM,
        quantity: rowData.Quantity,
        rate: rowData.Rate,
        amount: rowData.Amount,
        itemCategoryList: [],
        itemList: [],
      },
    ];

    setPopUpData(rowData);
    setPopUpData1(data);
  };

  const handleOpen = (isOpen) => { };

  const handleformFieldsChange = (value, name) => {
    setformFields((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const cancel = () => {
    setIsLoading(false);
    BindPurchase();
    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setpopUpOpen(false);
    setformFields({
      purchaseid: "PUR",
      purchasedate: "",
      purchasetype: "",
      SupplierName: "",
      Address: "",
      country: 1,
      State: "",
      City: "",
      Pincode: "",
      ContactPerson: "",
      Designation: "",
      MobileNumber: "",
    });
    setFormFieldsError({
      PurchaseIdError: "",
      PurchasedateError: "",
      PurchasetypeError: "",
      SupplierNameError: "",
      AddressError: "",
      CountryError: "",
      StateError: "",
      CityError: "",
      PincodeError: "",
      ContactPersonError: "",
      DesignationError: "",
      MobileNumberError: "",
    });
    setTableData([
      {
        itemType: "",
        itemCategoryId: "",
        itemId: "",
        quantity: "",
        rate: "",
        uom: "",
        amount: "",
        itemCategoryList: [],
        itemList: [],
      },
    ]);
    setsubmitBtnDisabled(false);
    setIsOpen(false);
    console.log("Form cancelled and reset");
  };

  const validateForm = () => {
    // validation logic
  };

  const handleInputChangeForm = (e) => {
    const { name, value } = e.target;
    setformFields((prev) => ({ ...prev, [name]: value }));
  };

  const [popUpViewOpen, setPopUpViewOpen] = useState(false);
  const [purchaseRecord, setPurchaseRecord] = useState([]);
  const [purchaseTableData, setPurchaseTableData] = useState([]);
  const showView = (rowIndex, flag) => {
    setPopUpViewOpen(true);

    const rowdata = bindPurchaseData[rowIndex];
    //setmainconsumeRecord(rowdata);
    setPurchaseRecord(rowdata);

    const TesttxnPurchaseId = bindPurchaseData[rowIndex].TxnPurchaseId;

    const filtered = purchaseChildData.filter(
      (item) => item && String(item.TxnPurchaseId) === String(TesttxnPurchaseId)
    );

    setPurchaseTableData(filtered);
  };

  const handleInputChangeTable = (selectedOption, rowIndex, columnName) => {
    const value = selectedOption ? selectedOption.value : "";
    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];
      updatedData[rowIndex] = { ...updatedData[rowIndex], [columnName]: value };
      convertArrayToJSONString(updatedData);
      return updatedData;
    });
  };
  const handleInputChangeTable2 = (input, rowIndex, columnName) => {
    const value = input?.value ?? input; // supports both event & dropdown
  
    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];
  
      updatedData[rowIndex] = {
        ...updatedData[rowIndex],
        [columnName]: value,
      };
  
      // 🔥 Auto calculate amount
      const qty = parseFloat(updatedData[rowIndex].quantity) || 0;
      const rate = parseFloat(updatedData[rowIndex].rate) || 0;
  
      updatedData[rowIndex].amount = qty * rate;
  
      return updatedData;
    });
  };
  const handleInputChangeTable1 = (selectedOption, rowIndex, columnName) => {
    const value = selectedOption ? selectedOption.value : "";

    const updatedTableData = [...tableData];
    updatedTableData[rowIndex][columnName] = value;

    // ✅ Validate duplicates when certain fields change
    if (columnName === "itemCategoryId" || columnName === "itemName") {
      const currentRow = updatedTableData[rowIndex];
      const isDuplicate = updatedTableData.some(
        (row, index) =>
          index !== rowIndex && // Exclude current row
          row.itemCategoryId === currentRow.itemCategoryId &&
          row.itemName === currentRow.itemName &&
          row.itemCategoryId &&
          row.itemName
      );

      if (isDuplicate) {
        toast.error(
          "Item with the same category and name already exists in the table."
        );
        return; // Stop update
      }
    }

    setTableData(updatedTableData);
    convertArrayToJSONString(updatedTableData);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const newErrors = { ...formFieldsError };
    if (!value) {
      newErrors[name] = "This field is required";
    } else {
      delete newErrors[name];
    }
    setFormFieldsError(newErrors);
  };

  const handleDeleteRow = (index) => {
    setTableData((prevData) => {
      const updatedTableData = prevData.filter((_, i) => i !== index);

      if (updatedTableData.length === 0) {
        const newRow = {
          itemType: "",
          itemCategoryId: "",
          itemId: "",
          quantity: "",
          rate: "",
          uom: "",
          amount: "",
          itemCategoryList: [],
          itemList: [],
        };
        return [newRow];
      }

      return updatedTableData;
    });
  };

  const handleAddRow = () => {
    if (tableData.length >= 4) {
      toast.error("Cannot add more than 4 rows.");
      return;
    }

    // Get the last row's itemCategoryId and itemName (if applicable)
    const lastRow = tableData[tableData.length - 1];

    // Check if the last row has both itemCategoryId and itemName selected
    if (lastRow && lastRow.itemCategoryId && lastRow.itemName) {
      // Check for duplicates in tableData
      const isDuplicate = tableData.some(
        (row, index) =>
          index !== tableData.length - 1 && // Exclude the last row itself
          row.itemCategoryId === lastRow.itemCategoryId &&
          row.itemName === lastRow.itemName
      );

      if (isDuplicate) {
        toast.error("Item with the same category and name already exists.");
        return;
      }
    } else {
      // Optionally, you can add a check to ensure itemCategoryId and itemName are selected
      toast.error(
        "Please select both Item Category and Item Name before adding a new row."
      );
      return;
    }

    // Add new row if validation passes
    setTableData([
      ...tableData,
      {
        itemType: "",
        itemCategoryId: "",
        itemId: "",
        quantity: "",
        rate: "",
        uom: "",
        amount: "",
        itemCategoryList: [],
        itemList: [],
      },
    ]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setformFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (items, flag) => {
    debugger
    try {
      if (flag === 1 || flag === 2) {
        setsubmitBtnDisabled(true);
        setIsLoading(true);

        const newErrors = {
          purchaseIdError: formFields.purchaseid ? "" : "Enter Purchase ID",
          purchasedateError: formFields.purchasedate ? "" : "Enter Purchase Date",
          purchasetypeError: formFields.purchasetype ? "" : "Select Purchase Type",
          supplierNameError: formFields.supplierName ? "" : "Enter Supplier Name",
          addressError: formFields.address ? "" : "Enter Address",
          countryError: formFields.country ? "" : "Select Country",
          stateError: formFields.state ? "" : "Select State",
          cityError: formFields.city ? "" : "Select City",
          pincodeError: formFields.pincode ? "" : "Enter Pincode",
          contactPersonError: formFields.contactPerson ? "" : "Enter Contact Person",
          designationError: formFields.designation ? "" : "Enter Designation",
          mobileNumberError: formFields.mobileNumber ? "" : "Enter Mobile Number",
        };

        setFormFieldsError(newErrors);

        const isFormValid = Object.values(newErrors).every((err) => err === "");

        if (!isFormValid) {

          setsubmitBtnDisabled(false);
          setIsOpen(true);
          setIsLoading(false);
          return;
        }

       
if (!tableData || tableData.length === 0) {
  // toast.error("Add at least one item in the table 👎");
  setsubmitBtnDisabled(false);
  setIsOpen(true);
  setIsLoading(false);
  return;
}

const invalidRow = tableData.some((row) =>
  !row.itemType ||
  !row.itemCategoryId ||
  !row.itemName ||
  !row.uom ||
  !row.quantity ||
  !row.rate ||
  !row.amount
);

if (invalidRow) {
  // toast.error("Fill all child table fields properly 👎");
  setsubmitBtnDisabled(false);
  setIsOpen(true);
  setIsLoading(false);
  return;
}

        const payload = {
          txnPurchaseId: formFields.txnPurchaseId
            ? formFields.txnPurchaseId
            : 0,
          mstClientId: parseInt(mstclientId),
          createdBy: parseInt(createdBy),
          flag: flag,
          purchaseId: formFields.purchaseid,
          purchaseDate: formFields.purchasedate || "",
          purchaseType: formFields.purchasetype,
          mstSupplierId: formFields.supplierName,
          address: formFields.address,
          mstCountryId: formFields.country,
          mstStateId: formFields.state,
          mstCityId: formFields.city,
          pincode: formFields.pincode,
          contactPerson: formFields.contactPerson,
          designation: formFields.designation,
          mobileNumber: formFields.mobileNumber,
          purchaseChild: JSON.stringify(
            tableData.map((row) => ({
              itemType: row.itemType,
              itemCategoryId: row.itemCategoryId,
              itemId: row.itemName,
              uomId: row.uom,
              quantity: row.quantity,
              rate: row.rate,
              amount: row.amount,
            }))
          ),
          remarks: formFields.remarks,
        };

        console.log("Payload =>", payload);

        const response = await IUDAPI(payload, "PurchaseAPI/IUDPurchase");
        const result = response?.data?.Table?.[0]?.Result;
        console.log("API Response =>", response);

        if (flag === 1 && result === "S") {
          toast.success("Purchase Added Successfully 👍", { duration: 2000 });
          setTimeout(cancel, 2000); // go back after insert
        } else if (flag === 2 && result === "M") {
          toast.success("Purchase Updated Successfully 👍", { duration: 1000 });
          setTimeout(cancel, 1000); // go back after update
        } else {
          toast.error("Failed to save Purchase 👎");
        }
      }
      // Delete / Block / Unblock
      else {
        const data = {
          txnPurchaseId: formFields.txnPurchaseId,
          createdby: parseInt(createdBy),
          flag,
        };

        const response = await IUDAPI(data, "PurchaseAPI/IUDPurchase");
        const result = response?.data?.Table?.[0]?.Result;

        if (flag === 3 && result === "D") {
          toast.success("Deleted successfully 🗑️", { duration: 2000 });
        } else if (flag === 4 && result === "B") {
          toast.success("Inactivated successfully 🚫", { duration: 2000 });
        } else if (flag === 5 && result === "UB") {
          toast.success("Activated successfully ✅", { duration: 2000 });
        } else {
          toast.error("Operation failed 👎");
        }

        setTimeout(cancel, 2000);
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      toast.error("Something went wrong 👎");
    } finally {
      setIsLoading(false);
      setsubmitBtnDisabled(false);
    }
  };

  const handlePopup = (rowIndex, flag) => {
    setpopUpOpen(true);
  };

  return (
    <MainLayout pageName={"3"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Purchase"
          header={PurchaseHeaders}
          records={bindPurchaseItemData}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handlePurchase}
          showAdd={showAdd}
        />
      )}

      {visibleAdd && (
        <>
          <div className="flex flex-col w-full">
            <div className={mainTable.clientMasterMainAdd}>
              <AddScreenTitle
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                title="Purchase"
              />
            </div>
          </div>

          <div className=" p-5 lg:h-96  ">
            <div className={mainTable.grid3}>
              <InputText
                inputType="text"
                title="Purchase ID"
                name="purchaseid"
                controlFunc={handleInputChangeForm}
                content={formFields.purchaseid}
                disabled={true}
                // tabIndex="11"
                isRequired={true}
              />

              <InputText
                inputType="date"
                title="Purchase Date"
                name="purchasedate"
                controlFunc={handleInputChange}
                content={formFields.purchasedate}
                placeholder="Enter Date"
                disabled={false}
                classStar={"text-red-500"}
                // tabIndex="9"
                isRequired={true}

                errorMessage={formFieldsError.purchasedateError}
              />

              <DropDown
                name="purchasetype"
                title="Purchase Type"
                type="select-one"
                classStar={"text-red-500"}
                options={bindPurchaseType}
                placeholder="Select Purchase Type"
                // tabIndex="12"
                isRequired={true}
                controlFunc={handleInputChange}
                selectedOption={formFields.purchasetype}
                errorMessage={formFieldsError.purchasetypeError}

              />

              {/* <InputText
                inputType="text"
                title="Supplier Name"
                name="supplierName"
                content={formFields.supplierName}
                controlFunc={handleInputChange}
                classStar="text-red-500"
                placeholder="Enter the Name"
                errorMessage={formFieldsError.supplierNameError}

              /> */}

 <AutoDropDown
  title="Supplier Name"
  options={supplierBindDD.map((i) => ({
    value: i.MstSupplierId,
    label: i.SupplierName,
    data: i, // 🔥 full object
  }))}
  placeholder="Select Supplier"
  name="supplierName"
 selectedOption={
    supplierBindDD
      .map((i) => ({
        value: i.MstSupplierId,
        label: i.SupplierName,
        data: i,
      }))
      .find((x) => x.value == formFields.supplierName)
  }
  Class="custom-class"
  classStar="text-red-500"
   controlFunc={(selectedOption, e) => {
    handleSupplierChange(selectedOption);
  }}

  controlFuncBlur={() => {
    setFormFieldsError((prev) => ({
      ...prev,
      supplierNameError: formFields.supplierName
        ? ""
        : "Select Supplier Name",
    }));
  }}
  errorMessage={formFieldsError.supplierNameError}
/> 

{/* <AutoDropDown
  title="Supplier Name"
  options={supplierBindDD.map((i) => ({
    value: i.MstSupplierId,
    label: i.SupplierName,
    data: i, // 🔥 full object
  }))}
  name="supplierName"
  selectedOption={
    supplierBindDD
      .map((i) => ({
        value: i.MstSupplierId,
        label: i.SupplierName,
        data: i,
      }))
      .find((x) => x.value == formFields.supplierName)
  }
  controlFunc={(selectedOption, e) => {
    handleSupplierChange(selectedOption);
  }}
/> */}

              <InputText
                inputType="text"
                title="Address"
                name="address"
                content={formFields.address}
                controlFunc={handleInputChange}
                disabled={true}
                classStar="text-red-500"
                errorMessage={formFieldsError.addressError}

              />
              <AutoDropDown
                title="Country"
                ref={countryRef}
                options={countryBindDD}
                disabled={true}
                placeholder="Select"
                name="country"
                selectedOption={countryBindDD.find(
                  (x) => x.value == formFields.country
                )}
                Class="custom-class"
                // tabIndex="1"
                classStar="text-red-500"
                controlFunc={(value, e) => {
                  handleformFieldsChange(value.value, e.name);
                }}
                controlFuncBlur={() => {
                  setFormFieldsError((prev) => ({
                    ...prev,
                    countryError: formFields.country ? "" : "Select Country",
                  }));
                }}
                errorMessage={formFieldsError.countryError}
              />

              <AutoDropDown
                title="State"
                ref={stateRef}
                options={stateBindDD}
                placeholder="Select"
                disabled={true}
                name="state"
                selectedOption={stateBindDD.find(
                  (x) => x.value == formFields.state
                )}
                Class="custom-class"
                // tabIndex="1"
                classStar="text-red-500"
                // disabled={!formFields.country}
                controlFunc={(value, e) => {
                  handleformFieldsChange(value.value, e.name);
                }}
                controlFuncBlur={() => {
                  setFormFieldsError((prev) => ({
                    ...prev,
                    stateError: formFields.state ? "" : "Select State",
                  }));
                }}
                errorMessage={formFieldsError.stateError}
              />

              <AutoDropDown
                title="City"
                ref={branchProjectRef}
                options={branchProjectBindDD}
                placeholder="Select"
                disabled={true}
                name="city"
                selectedOption={branchProjectBindDD.find(
                  (x) => x.value == formFields.city
                )}
                Class="custom-class"
                // tabIndex="1"
                classStar="text-red-500"
                // disabled={!formFields.state}
                controlFunc={(value, e) => {
                  handleformFieldsChange(value.value, e.name);
                }}
                controlFuncBlur={() => {
                  setFormFieldsError((prev) => ({
                    ...prev,
                    cityError: formFields.city ? "" : "Select City",
                  }));
                }}
                errorMessage={formFieldsError.cityError}
              />

              <InputText
                inputType="number"
                title="PinCode"
                name="pincode"
                content={formFields.pincode}
                controlFunc={handleInputChange}
                controlFuncBlur={handleBlur}
                classStar={"text-red-500"}
                placeholder="Enter Pincode"
                errorMessage={formFieldsError.pincodeError}
                disabled={true}
              />
            </div>

            <div class="grid gap-4 mb-6 md:grid-cols-3">
              <InputText
                inputType="text"
                title="Contact Person"
                name="contactPerson"
                classStar="text-red-500"
                disabled={true}
                maxLength={100}
                content={formFields.contactPerson} // ✅ bind to formFields, not error state
                controlFunc={(e) =>
                  setformFields({
                    ...formFields,
                    contactPerson: e.target.value,
                  })
                }
                controlFuncBlur={(e) => {
                  const value = e.target.value;
                  setFormFieldsError((prev) => ({
                    ...prev,
                    contactPersonError:
                      value.trim().length > 0
                        ? /^[A-Za-z ]+$/.test(value)
                          ? ""
                          : "Only alphabets and space allowed"
                        : "Enter Contact Person",
                  }));
                }}
                errorMessage={formFieldsError.contactPersonError}
              />

              <InputText
                inputType="text"
                title="Designation"
                name="designation"
                classStar={"text-red-500"}
                content={formFields.designation}
                controlFunc={handleInputChange}
                controlFuncBlur={handleBlur}
                errorMessage={formFieldsError.designationError}
                disabled={true}
              />

              <InputText
                inputType="text"
                title="Contact Number"
                name="mobileNumber"
                maxLength="10"
                placeholder="Enter the Number"
                classStar={"text-red-500"}
                content={formFields.mobileNumber}
                controlFunc={handleInputChange}
                controlFuncBlur={handleBlur}
                errorMessage={formFieldsError.mobileNumberError}
                disabled={true}
              />
            </div>
            <div className="shadow-md p-4 rounded-md bg-white overflow-y-auto h-96">
              <form onSubmit={handleSubmit}>
                <table className="min-w-full table-auto border border-gray-300">
                  <thead className="bg-[#3D6643]  text-white sticky top-0 z-10">
                    <tr>
                      <th className="border px-2 py-2 w-[30px]">SN</th>
                      <th className="border px-4 py-2 w-[200px]">Item Type</th>
                      <th className="border px-4 py-2 w-[200px]">Category</th>
                      <th className="border px-4 py-2 w-[230px]">Name</th>
                      <th className="border px-4 py-2 w-[90px]">Quantity</th>
                      <th className="border px-4 py-2 w-[100px]">U.O.M</th>
                      <th className="border px-4 py-2 w-[100px]">Rate</th>
                      <th className="border px-4 py-2 w-[100px]">Amount</th>
                      <th className="border px-4 py-2">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, index) => (
                      <tr key={index}>
                        <td className="border px-2 py-2">{index + 1}</td>
                        <td className="border px-4 py-2">
                          <AutoDropDown
                            name="itemType"
                            Class="custom-class"
                            options={itemTypeDropdown}
                            selectedOption={
                              row.itemType
                                ? itemTypeDropdown.find(
                                  (x) => x.value === row.itemType
                                )
                                : ""
                            }
                            controlFunc={(e) => {
                              handleInputChangeTable(
                                e,
                                index,
                                "itemType",
                                true
                              );
                            }}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <AutoDropDown
                            name="itemCategoryId"
                            Class="custom-class"
                            options={row.itemCategoryList || []}
                            selectedOption={
                              (row.itemCategoryList &&
                                row.itemCategoryList.find(
                                  (opt) => opt.value === row.itemCategoryId
                                )) ||
                              null
                            }
                            controlFunc={(e) =>
                              handleInputChangeTable(
                                e,
                                index,
                                "itemCategoryId",
                                true
                              )
                            }
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <AutoDropDown
                            name="itemName"
                            Class="custom-class"
                            options={row.itemList || []}
                            selectedOption={
                              (row.itemList &&
                                row.itemList.find(
                                  (opt) => opt.value === row.itemName
                                )) ||
                              null
                            }
                            content={row.itemName}
                            controlFunc={(e) =>
                              handleInputChangeTable(e, index, "itemName", true)
                            }
                          />
                        </td>

                        <td className="border px-4 py-2">
                          <div title={`Min Stock: ${row.currentStock || 0}`}>
                            <InputText
                              type="number"
                              name="quantity"
                              value={row.quantity}
                              content={row.quantity}
                              controlFunc={(e) => {
                                const InputText = e.target.value;

                                if (InputText === "" || /^\d+$/.test(InputText)) {
                                  handleInputChangeTable2(
                                    e.target,
                                    index,
                                    "quantity"
                                  );
                                }
                              }}
                              controlFuncBlur={(e) => {
                                const inputValue = e.target.value;

                                // Validate the value when the user leaves the field
                                if (
                                  inputValue !== "" &&
                                  parseFloat(inputValue) <
                                  (row.currentStock || 0)
                                ) {
                                  handleInputChangeTable2(
                                    { value: "" },
                                    index,
                                    "quantity"
                                  ); // Clear the value if invalid
                                }
                              }}
                            />
                          </div>
                        </td>
                        <td className="border px-4 py-2">
                          <InputText
                            name="uom"
                            content={row.uom}
                            controlFunc={(e) =>
                              handleInputChangeTable(e, index, "uom")
                            }
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <InputText
                            type="number"
                            name="rate"
                            value={row.rate}
                            content={row.rate}
                            controlFunc={(e) => {
                              const InputText = e.target.value;

                              if (/^\d+$/.test(InputText)) {
                                handleInputChangeTable2(e.target, index, "rate");
                              }
                            }}
                          />
                        </td>

                        <td className="border px-4 py-2">
                          <InputText
                            type="number"
                            name="amount"
                            value={row.amount}
                            content={row.amount}
                            maxLength={6}
                            disabled={true}
                            controlFunc={(e) => {
                              const InputText = e.target.value;

                              if (/^\d+$/.test(InputText)) {
                                handleInputChangeTable2(
                                  e.target,
                                  index,
                                  "amount"
                                );
                              }
                            }}
                          />
                        </td>

                        <td className="border px-4 py-2">
                          <div className="flex gap-4 items-center justify-center">
                            {addScreenTitle && (
                              <svg
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                className="w-6 h-6 text-black cursor-pointer"
                                onClick={() => handleDeleteRow(index)}
                              >
                                <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                              </svg>
                            )}
                            {row.currentDelete >= row.quantity &&
                              updateScreenTitle && (
                                <svg
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  className="w-6 h-6 text-black cursor-pointer"
                                  onClick={() => handleDeleteRow(index)}
                                >
                                  <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                                </svg>
                              )}

                            {index === tableData.length - 1 &&
                              tableData.length < 4 && (
                                <svg
                                  viewBox="0 0 1024 1024"
                                  fill="currentColor"
                                  onClick={handleAddRow}
                                  className="w-6 h-6 text-black cursor-pointer"
                                >
                                  <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                                </svg>
                              )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div>
                  <TextArea
                    title="Remarks"
                    name="remarks"
                    placeholder="Remarks"
                    rows={3}
                    maxLength={500}
                    // tabIndex="1"
                    content={formFields.remarks}
                    controlFunc={handleInputChangeForm}
                  />
                </div>
              </form>
            </div>
            <div className="flex justify-center mt-6 gap-4">
              <Buttons
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                viewSaveButton={false}
                handleSubmit={handleSubmit}
                disabledBtn={submitBtnDisabled}
                cancel={cancel}
              />
            </div>
          </div>
        </>
      )}  {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}

      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handlePurchase}
      >
        <div>
          <PopUpScreenTitle
            title="Purchase"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <PurchasePopup data={popUpData} data1={popUpData1} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          handleSubmit={handleSubmit}
          cancel={cancel}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default PurchaseItem;
